import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'
import { isEmpty } from 'lodash'

export default function homeDataLayerBody(stateId, locations, imoveis, path) {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'dados-imoveis',
      showLocation: 'carrossel-body',
      pagepath: path,
      pageType: 'home',
      estado: !isEmpty(imoveis) && !!imoveis[0].Endereco ? TOOLS.slugify(imoveis[0].Endereco.Estado) : '',
      cidade: !isEmpty(imoveis) && !!imoveis[0].Endereco ? TOOLS.slugify(imoveis[0].Endereco.Cidade) : '',
      imoveis: imoveis.map((h, index) => {
        return {
          id: h.ImovelId,
          nome: TOOLS.slugify(h.Nome),
          bairro: TOOLS.slugify(h.Endereco.Bairro),
          cidade: TOOLS.slugify(h.Endereco.Cidade),
          estado: TOOLS.slugify(h.Endereco.Estado),
          areaprivativa: h.AreaPrivativaM2 ? TOOLS.slugify(h.AreaPrivativaM2) : undefined,
          dormitorios: TOOLS.slugify(h.Quartos),
          vagas: h.VagasGaragem,
          valor: h.PrecoMinimo ? FILTERS.moneyBi(h.PrecoMinimo) : undefined,
          status: h.Status ? TOOLS.slugify(h.Status) : undefined,
          position: index,
        }
      }),
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/homeDataLayerBody.js